import { z as builder } from "zod"
import { DEV_MODE } from "@/config"

export const loginSchema = builder.object({
    username: builder.string().min(1, "Este campo es obligatorio"),
    password: DEV_MODE ? builder.string().optional() : builder.string().min(1, "Este campo es obligatorio").nonoptional()
})

export type LoginSchema = builder.infer<typeof loginSchema>
